export default "__VITE_ASSET__X7uwF3zt__"